<template lang="html">
    <div class="notification-item" @click="seeMore" 
        :class="{'notification-item--dropdown': dropdown}">
        <div class="notification-item__content">
            <div class="notification-item__avatar">
                <img 
                    src="@/assets/images/logo.svg"
                    class="notification-item__image notification-item__image--logo"
                    alt = "nexyo logo"
                    v-if="initiator == 'admin'">
                <img
                    :src="imageUrl"
                    class="notification-item__image"
                    alt="specialist picture"
                    v-else-if="imageUrl">
                <img
                    src="@/assets/images/person-icon.png"
                    class="notification-item__image"
                    alt="person icon"
                    v-else-if="initiator == 'client'">
                <div class="notification-item__status notification-item__status--nexyo" :class="notificationBgColor">
                </div>
                <div class="notification-item__icon" :class="notificationBgColor">
                    <i class="fas fa-handshake" v-if="type == 'appointment_reminder'"></i>
                    <i class="fas fa-calendar-plus" v-else-if="type == 'appointment_created'"></i>
                    <i class="fas fa-calendar-minus" v-else-if="type == 'appointment_canceled'"></i>
                    <i class="fas fa-star" v-else-if="type == 'review_created'"></i>
                    <i class="fas fa-comment-dots" v-else></i>
                    <!-- <i class="fas fa-comment-dots" v-if="type == 'announcement'"></i> -->
                </div>
            </div>
            <div class="notification-item__details">
                <div class="notification-item__title">
                    {{title}}
                </div>

                <div class="notification-item__text">
                    {{text}}
                </div>
                <div class="notification-item__date">
                    {{momentDate}}
                </div>
            </div>
        </div>
        <div v-if="dropdown" class="notification-item__bullet"></div>
        <div v-else-if="type == 'appointment_reminder' || type == 'appointment_created' || type == 'review_created'" 
            class="notification-item__button" @click="viewNotificationDetails">
            Vezi detalii
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            type: {
                type: String,
                default: ''
            },
            title: {
                type: String,
                default: ''
            },
            text: {
                type: String,
                default: ''
            },
            date: {
                type: String,
                default: ''
            },
            imageUrl: {
                type: String,
                default: ''
            },
            initiator: {
                type: String,
                defualt: ''
            },
            dropdown: {
                type: Boolean,
                default: false
            },
            user: {
                type: Object,
                default: null
            }
        },
        computed: {
            notificationBgColor() {
                if (this.type == "appointment_canceled")
                    return "notification-item__background--canceled";
                if (this.type == "review_created")
                    return "notification-item__background--new-review";
                if (this.type == "nexyo")
                    return "notification-item__background--nexyo";
                else
                    return "notification-item__background"
            },
            momentDate() {
                var date = new Date(this.date);
                const start = this.$moment(date.getTime());
                return 'acum '+this.$moment.duration(this.$moment().diff(start)).humanize();
            }
        },
        methods: {
            seeMore() {
                if(this.dropdown)
                {
                    this.$emit('exit');
                    this.$router.push(this.link);
                }
            },
            viewNotificationDetails() {
                if(this.type == "review_created")
                {
                    this.$router.push(`/specialists/profile/${this.user.id}`);
                }
                else
                {
                    this.$router.push(`/${this.user.role}/appointments`);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .notification-item {
        background-color: $color-card;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.06);
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        transition: all .3s ease-in-out;
        margin-top: 20px;
        animation-name: notification-item-anim;
        animation-duration: .5s;
        animation-fill-mode: forwards;
        animation-timing-function: ease-in-out;


        &:hover {
            background-color: transparent;
            box-shadow: none;
        }

        &__content {
            display: flex;
            align-items: center;
            margin: 15px;
        }

        &__details {
            margin-left: 30px;
        }

        &__button {
            display: none;
            width: 105px;
            min-width: 105px;
            height: 35px;
            border-radius: 18px;
            border: 2px solid $color-primary;
            background-color: $color-primary;
            color: $color-card;
            transition: all .25s ease-in-out;
            cursor: pointer;
            user-select: none;
            white-space: nowrap;
            margin-right: 15px;

            @include media-breakpoint-up(md) {
                @include center-flex;
            }

            &:hover {
                background-color: transparent;
                color: $color-primary;
            }
        }

        &__bullet {
            min-width: 12px;
            width: 12px;
            height: 12px;
            background: $color-primary;
            border-radius: 12px;
        }

        &__title {
            font-size: 16px;
            line-height: 18.75px;
            font-weight: 500;
            font-family: 'Roboto';
            margin-bottom: 12px;
        }

        &__text {
            font-size: 14px;
            line-height: 17.36px;
            font-weight: 400;
            font-family: 'DIN Pro';
            margin-bottom: 15px;
        }

        &__date {
            font-size: 12px;
            line-height: 14px;
            font-weight: 500;
            font-family: 'Roboto';
            color: $color-primary;
        }

        &__avatar {
            position: relative;
            width: 60px;
            height: 60px;
            border-radius: 100%;
            margin-left: 10px;

            @include media-breakpoint-up(sm) {
                margin-left: 0;
            }
        }

        &__image {
            position: relative;
            min-width: 60px;
            min-height: 60px;
            width: 60px;
            height: 60px;
            object-fit: cover;
            border-radius: inherit;
            z-index: 2;
            font-size: 12px;

            &--logo {
                object-fit: contain;
            }
        }

        &__status {
            position: absolute;
            height: 66px;
            width: 66px;
            top: 50%;
            left: 50%;
            border-radius: 100%;
            transform: translate(-50%, -50%);
            background-color: $color-primary;
            z-index: 0;

            &::after {
                content: "";
                position: absolute;
                height: 60px;
                width: 60px;
                background-color: $color-card;
                border-radius: 100%;
                transform: translate(-50%, -50%);
                top: 50%;
                left: 50%;
                z-index: 1;
            }
        }

        &__icon {
            position: absolute;
            height: 35px;
            width: 35px;
            @include center-flex;
            color: white;
            bottom: -10px;
            right: -10px;
            background-color: $color-primary;
            border: 3px solid $color-card;
            border-radius: 100%;
            z-index: 2;
            font-size: 16px;

            & > i:hover {
                color: $color-card;
                transform: none;
            }
        }

        &__background {
            background-color: $color-primary;

            &--canceled {
                background-color: $color-danger;
            }

            &--new-review {
                background-color: $color-warning;
            }

            &--nexyo {
                background-color: transparent;
                background: $gradient-nexyo;
            }
        }
    }

    .notification-item--dropdown {
        margin-top: 5px;
        margin-bottom: 10px;
        
        .notification-item__content {
            margin: 5px;
        }

        .notification-item__details {
            margin-left: 15px;
        }
    }

    @keyframes notification-item-anim {
        from {
            opacity: 0;
            transform: translateX(10px);
        }

        to {
            opacity: 1;
            transform: translateX(0);
        }
    }
</style>